import { render } from "./BacEmbed.vue?vue&type=template&id=2488325d&scoped=true"
import script from "./BacEmbed.vue?vue&type=script&lang=js"
export * from "./BacEmbed.vue?vue&type=script&lang=js"

import "./BacEmbed.vue?vue&type=style&index=0&id=2488325d&scoped=true&lang=css"

import exportComponent from "D:\\work\\application\\棋牌游戏5.0\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2488325d"]])

export default __exports__